import { ensureTab, getRows, updateRow, appendRow, findRowIndexById, deleteRow } from '../lib/googleSheets';

const TAB_NAME = 'Vocabulary';
const HEADERS = [
  'id', 'term', 'sourceUrl', 'sourceTitle', 'plainEnglish', 'context', 'spanishSummary', 'simpleWay', 'exampleSentence', 'keyTerms', 'dateAdded', 'category', 'color', 'created_at', 'updated_at'
];

const SOFT_COLORS = [
  '#FFB5A7', '#A8E6CF', '#FFD3B6', '#D4A5A5', '#9EA1D4', '#B5EAD7', '#E2F0CB'
];

const mapRowToObj = (row) => {
  const obj = {};
  HEADERS.forEach((header, index) => {
    let val = row[index];
    if (header === 'keyTerms') {
      try {
        if (typeof val === 'string' && (val.startsWith('[') || val.startsWith('{'))) {
          val = JSON.parse(val);
        } else {
          val = val ? val.split(',').map(t => t.trim()).filter(Boolean) : [];
        }
      } catch {
        val = [];
      }
    }
    obj[header] = val || '';
  });
  return obj;
};

const mapObjToRow = (obj) => {
  return HEADERS.map(header => {
    let val = obj[header];
    if (header === 'keyTerms') return JSON.stringify(val || []);
    return val || '';
  });
};

export const vocabService = {
  async getAll() {
    await ensureTab(TAB_NAME, HEADERS);
    const rows = await getRows(`${TAB_NAME}!A2:O`);
    const processed = [];
    
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      let obj = mapRowToObj(row);
      
      // Critical: Ensure every row has a UUID in the sheet
      if (!obj.id || String(obj.id).trim() === '') {
        const now = new Date().toISOString();
        const enrichedData = {
          ...obj,
          id: crypto.randomUUID(),
          color: obj.color || SOFT_COLORS[i % SOFT_COLORS.length],
          dateAdded: obj.dateAdded || now.split('T')[0],
          created_at: obj.created_at || now,
          updated_at: now
        };
        const sheetRowIndex = i + 2;
        try {
          await updateRow(`${TAB_NAME}!A${sheetRowIndex}:O${sheetRowIndex}`, mapObjToRow(enrichedData));
          obj = enrichedData;
        } catch (err) {
          console.error(`Row repair failed for index ${sheetRowIndex}:`, err);
        }
      }
      processed.push(obj);
    }
    return processed;
  },

  async create(data) {
    await ensureTab(TAB_NAME, HEADERS);
    const now = new Date().toISOString();
    
    const newVocab = {
      ...data,
      id: crypto.randomUUID(),
      color: data.color || SOFT_COLORS[Math.floor(Math.random() * SOFT_COLORS.length)],
      dateAdded: now.split('T')[0],
      created_at: now,
      updated_at: now
    };
    
    await appendRow(`${TAB_NAME}!A:O`, mapObjToRow(newVocab));
    return newVocab;
  },

  async update(id, data) {
    const rowIndex = await findRowIndexById(TAB_NAME, id);
    if (rowIndex === -1) throw new Error('Term not found in database. Please refresh.');
    
    const updatedVocab = { 
      ...data, 
      id, 
      updated_at: new Date().toISOString() 
    };
    
    await updateRow(`${TAB_NAME}!A${rowIndex}:O${rowIndex}`, mapObjToRow(updatedVocab));
    return updatedVocab;
  },

  async delete(id) {
    if (!id) throw new Error('Cannot delete without a valid ID');
    return deleteRow(TAB_NAME, id);
  },

  async seedIfEmpty(mockData) {
    await ensureTab(TAB_NAME, HEADERS);
    const rows = await getRows(`${TAB_NAME}!A2:A`);
    if (rows.length === 0) {
      for (const item of mockData) {
        await this.create(item);
      }
    }
  }
};